// generated by genversion
export var version = '3.4.7';
//# sourceMappingURL=version.js.map